import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const RightContestaciones = () => {
    return (
      <Box sx={{ width: '20%', bgcolor: 'primary.medio', p: 2}}>
        <Typography variant="body1">Módulos</Typography>
        <Button sx={{mt:2, fontSize:10}} color="secondary" variant="contained">Procesador documentos</Button>
        <Button sx={{mt:2}} color="secondary" variant="contained">Respuestas</Button>

      </Box>
    );
};

export default RightContestaciones;
